import React, { useEffect, useCallback, useMemo } from "react";
import { Grid } from "@mui/material";
import NavigateBackHeader from "../../../../core/core-components/NavigateBackHeader/NavigateBackHeader";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { isNullOrUndefined } from "../../../../shared/utils/utils.js";
import PubgCharge from "./PubgCharge.jsx";
import { ErrorBoundary } from "react-error-boundary";
import ErrorBoundaryMessage from "components/ErrorBoundary/ErrorBoundaryMessage";

const { useGoBackIf } = require("../../../../shared/hooks");

const GamesCharge = () => {
  const gamesList = useSelector((state) => state?.games?.gamesArray) || [];
  const { id: gameId } = useParams();
  const goBackIf = useGoBackIf("");
  const history = useHistory();

  // Find current game - memoize to prevent recalculation
  const currentGame = useMemo(() => {
    return gamesList.find((game) => game.id === gameId);
  }, [gamesList, gameId]);

  // Redirect if no games loaded
  useEffect(() => {
    goBackIf(!gamesList.length);
  }, [goBackIf, gamesList.length]);

  // Redirect if game not found
  useEffect(() => {
    if (gamesList.length > 0 && isNullOrUndefined(currentGame)) {
      goBackIf(true);
    }
  }, [currentGame, gamesList.length, goBackIf]);

  // Memoize navigation handler
  const handleBackClick = useCallback(() => {
    history.push("/gaming");
  }, [history]);

  // Memoize error handler
  const handleError = useCallback((error) => {
    console.error("Game charge error:", error);
  }, []);

  // Early return if no game found
  if (!currentGame && gamesList.length > 0) {
    return null;
  }

  return (
    <Grid container>
      <Grid item md={12} xs={12}>
        <NavigateBackHeader
          onBackClick={handleBackClick}
          title={currentGame?.company_name || "Gaming"}
        />
      </Grid>
      <Grid item md={12} xs={12}>
        <ErrorBoundary
          FallbackComponent={ErrorBoundaryMessage}
          onError={handleError}
        >
          <PubgCharge gameName={currentGame?.company_name} />
        </ErrorBoundary>
      </Grid>
    </Grid>
  );
};

export default GamesCharge;

